import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { isNullOrWhiteSpace } from 'ecs-react-components/dist/index.es';
import { messages } from './familyHistory.i18n';
import { SecondaryDisplayItem } from './secondaryDisplayItem';

export class FamilyHistoryDetail extends React.Component {
  configurationActive = (fieldName) => {
    if (this.props.capabilities.details.find((x) => x.fieldName === fieldName)) {
      return true;
    }
    return false;
  }

  render() {
    const currentStatus = isNullOrWhiteSpace(this.props.familyHistory.currentStatusDisplay) ?
      this.props.familyHistory.currentStatus :
      this.props.familyHistory.currentStatusDisplay;
    const relationship = isNullOrWhiteSpace(this.props.familyHistory.relationshipDisplay) ?
      this.props.familyHistory.relationship :
      this.props.familyHistory.relationshipDisplay;

    return (
      this.props.familyHistory.isNullMessageHolder === false ?
      <div className="row item-row" data-qa={'familyHistory_' + relationship}>
        <div className="col-md-4 primary-data">
          {
            this.props.familyHistory.isPatientReviewed === false ?
              <span className="fa fa-circle"></span> : null
          }
          {relationship}
        </div>
        <div className="col-md-8 secondary-data">
            <div className="inline-list">
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.cancerDiagnosis} />}
                value={this.props.familyHistory.cancerDiagnosis} language={this.props.language}
                isActive={this.configurationActive('CancerDiagnosis')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.ageAtDiagnosis} />}
                value={this.props.familyHistory.ageAtDiagnosis} language={this.props.language}
                isActive={this.configurationActive('AgeAtDiagnosis')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.currentStatus} />}
                value={currentStatus} language={this.props.language}
                isActive={this.configurationActive('CurrentStatus')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.comment} />}
                value={this.props.familyHistory.comment} language={this.props.language}
                isActive={this.configurationActive('Comment')}
              />
            </div>
        </div>
      </div>
        :
      <div className="row item-row" data-qa="familyHistory_nullMessage">
        <div className="col-md-4 primary-data">
          {this.props.familyHistory.nullMessage}
        </div>
      </div>
    );
  }
}

FamilyHistoryDetail.propTypes = {
  familyHistory: PropTypes.object.isRequired,
  language: PropTypes.string,
  capabilities: PropTypes.object.isRequired,
};
